export const PROGRESS_METRIC_EXPLANATIONS = {
  trainingConsistency:
    "Percentage of weeks in the selected period that contain at least one eligible activity.",
  wattsPerKg:
    "Power divided by body weight. It helps compare cycling performance between riders of different sizes.",
  measuredPower: "Power recorded directly by a power meter.",
  smartTrainerPower: "Power recorded by a connected indoor trainer.",
  estimatedPower:
    "Power estimated from speed, elevation, weight, and other available data. It may be less accurate than measured power.",
  unknownPowerSource:
    "Power data is present, but the recording source could not be confirmed.",
  acuteLoad: "Average daily training load over the most recent 7 days.",
  chronicLoad: "Average daily training load over the most recent 28 days.",
  form:
    "How recent training load compares with longer-term load. Form is chronic load minus acute load. It is not coaching readiness.",
  monotony: "Average daily load for the week divided by the variation in daily load.",
  strain: "Weekly training load multiplied by monotony.",
  loadSpike: "Current weekly load is at least 1.5 times the previous week.",
  readinessConfidence:
    "The current coaching readiness record. It is separate from training form.",
  durationFallback:
    "Training load was estimated mainly from activity duration because reliable power or heart-rate data was unavailable.",
};
